var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',{staticClass:"toggle-facet"},[_c('b-field',[_c('b-switch',{on:{"input":_vm.onFacetChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(_vm._s(_vm.facet.displayName))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }